import {TrancheReductionMl} from "../../models/gestion-conditionnements/tranche-reduction-ml";

export class TrancheReductionDTO {
  start: Number;
  quantityAllowed: Number;

  constructor(model: TrancheReductionMl) {
    this.start = model.start;
    this.quantityAllowed = model.quantityAllowed;
  }
}
